module.exports = __webpack_public_path__ + "static/resource-hiring-remotely-24505fa08c16c6549067f21334d2a16b.png";